module.exports = __webpack_public_path__ + "img/miniPro_judai_gongneng.902330ce.png";